import type { MermaidConfig } from "mermaid"

let mermaidPromise: Promise<typeof import("mermaid").default> | null = null

export async function getMermaid(): Promise<typeof import("mermaid").default> {
  // Cache the in-flight import+init promise so concurrent first calls share a
  // single initialization instead of racing to initialize Mermaid twice.
  if (!mermaidPromise) {
    mermaidPromise = (async () => {
      const { default: mermaid } = await import("mermaid")
      mermaid.initialize({
        startOnLoad: false,
        theme: "default",
        securityLevel: "strict",
        suppressErrorRendering: true,
      } as MermaidConfig)
      return mermaid
    })()
  }
  return mermaidPromise
}
